import { Box, Modal } from "@mui/material";
import { useState, useRef } from "react";
import React from 'react';
import "../../components/importModal/Modal.css";
import { mdmDataUpload } from '../../services/mdmService';
import store from '../../stateManagement/store';
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { LoadingOverlay } from "@mantine/core";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { importMdmDataModalProps } from "../../components/importModal/importMdmDataModal.type";
import RenderSvg from "../../components/renderSvg/RenderSvg";

const excelFileTypes=  ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv";
const zipFileTypes = ".zip, .rar"

const ImportNewMdmDataModal = (props: importMdmDataModalProps) => {
    const { translate } = usePortalTranslation();
	const CUR_COMPONENT = "Import";
    const CUR_COMPONENT_COMMON="commonPortal";
    const entityName: string = store?.getState()?.mdmDashboardReducer?.currentMdmEntity?.entityName;
    const useKafka: boolean = store?.getState()?.mdmDashboardReducer?.currentMdmEntity?.useKafka ?? false;
    const mdmName: string = store?.getState()?.mdmDashboardReducer?.currentMdmEntity?.name;
    const fileType = store?.getState()?.mdmDashboardReducer?.currentMdmEntity?.fileType;
    const acceptAttribute = fileType==="zip"? zipFileTypes : excelFileTypes;
    const [blobData, setBlobData] = useState(new FormData());
    const [file, setFile] = useState<File>();
    const [fileName, setFileName] = useState<string>("");
    const [uploadColor, setUploadColor] = useState("grey");
    const [loader,setLoader] = useState<boolean>(false);

    const inputE1 = useRef<HTMLInputElement>(null);
    const onButtonClick = () => {
        if (inputE1.current) {
            inputE1.current.click();
        }
    };

    const importOnClick = () => {
        props.setShowModal(false); 
        setFileName("");
        setUploadColor("grey");
    }

    const uploadOnClick = async(e:React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        if(uploadColor === 'grey'){
            openPopup("Error","Please select a file");
            return;
        }
        setLoader(true)
        props.setShowModal(false); 
        const transformerInfo = store?.getState()?.mdmDashboardReducer?.currentMdmEntity?.transformer;
        await mdmDataUpload(blobData, entityName, file, setLoader, useKafka, transformerInfo); 
        setFileName(""); 
        setUploadColor("grey");
    }

    return (
        <>
            <Modal
                open={props.Open}
                onClose={() => { props.setShowModal(false) }}
            >
                <Box className="import-mdm-modal-wrapper">

                    <div className="import-mdm-modal-container">

                        <div className="import-mdm-modal-header">
                            <div className="import-mdm-modal-title">{translate(TranslationEnum.common_portal,"Import")} {translate(TranslationEnum.import,mdmName)} </div>
                            <button className="import-mdm-modal-close-btn" onClick={importOnClick}>&times;</button>
                        </div>

                        <div className="import-mdm-modal-body">
                            <div className="import-mdm-modal-body-heading">{translate(TranslationEnum.import,"Upload {mdmName} template filled with your data",{"mdmName":mdmName})} </div>
                            <div className="import-mdm-download-icon">
                                {props.downloadUrl && <a className="import-mdm-box" href={props.downloadUrl} >

                                    <div className='import-mdm-icon'>
                                    <RenderSvg name='DownloadImportButton' />
                                    </div>

                                    <span className="import-mdm-click-btn" > {translate(TranslationEnum.common_portal,"Download")} </span>
                                </a>}
                                <div className="import-mdm-box" onClick={onButtonClick}>
                                    <div style={{ flex: "70%" }}>
                                        <input type="file" ref={inputE1} hidden
                                            accept={acceptAttribute}
                                            onChange={(event) => {
                                                const fileToBeUploaded = event.currentTarget.files?.[0];
                                                setFile(fileToBeUploaded)
                                                setFileName(fileToBeUploaded?.name as string)
                                                if (fileToBeUploaded) {
                                                    const data = new FormData();
                                                    data.append("file", fileToBeUploaded)
                                                    setBlobData(data)
                                                }
                                                if(event.currentTarget.value){
                                                    setUploadColor("#24c6b1")
                                                }
                                            }} />
                                        <div className='import-mdm-icon'> 
                                        <RenderSvg name='UploadImportButton' /> 
                                        </div>
                                    </div>
                                    <div className="import-mdm-file-Name">
                                        <p>
                                                {fileName}
                                        </p>
                                    </div>
                                        <button className="click-btn-upload " style={{ backgroundColor: uploadColor }} onClick={(e) => { uploadOnClick(e) }} > {translate(TranslationEnum.common_portal,"Upload")} </button>
                                </div>
                            </div>
                        </div>

                    </div>                   
                </Box>
            </Modal>
            {loader ? <LoadingOverlay visible={loader} /> :""}   
        </>
    );


}

export default ImportNewMdmDataModal;
